module.exports = __webpack_public_path__ + "static/media/plus.229b9f9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/plus.svg
// module id = 1946
// module chunks = 35